import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";

// Đưa Interceptor ra ngoài
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function Request() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // Quản lý Phân trang và Tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // Hàm lấy dữ liệu
    const fetchWithdrawals = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/rut?page=${page}&limit=${limit}&search=${searched}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchWithdrawals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched]);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <div className="container_set">{t("withdraw")}</div>
                            <div className="form_set">
                                <Box>
                                    <TextField defaultValue="" onChange={handleSearchChange} placeholder={t("search")} />
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px" }}>{t("username")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>ID</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("payment")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("money")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("balance")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("status")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("more")}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{t("time")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {/* Hiển thị thẳng dữ liệu */}
                                                {data.map((item) => (
                                                    <TableRow key={item._id}>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.username}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.iduser}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.detail}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{Number(item?.money).toLocaleString("vi-VN")} </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                            <span>{item?.user?.money?.toLocaleString("vi-VN")}</span>
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {item?.status_payment === "Pending" && <span className="badge warning">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Success" && <span className="badge success">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Deny" && <span className="badge error">{item?.status_payment}</span>}
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {profile?.permission?.money == 1 ? (
                                                                <>
                                                                    <textarea
                                                                        type="text"
                                                                        name="note"
                                                                        defaultValue={item?.note}
                                                                        disabled={item?.status_payment !== "Pending"}
                                                                        onChange={(e) => setNote(e.target.value)}
                                                                    />
                                                                    <Button
                                                                        onClick={() => {
                                                                            setLoading(true);
                                                                            const formData = {
                                                                                id: item?._id,
                                                                                status: "Accept",
                                                                                note: note
                                                                            };
                                                                            axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                .then(() => {
                                                                                    swal(t("success"), "", "success");
                                                                                    fetchWithdrawals(); // Fetch lại thay vì reload
                                                                                })
                                                                                .catch(() => {
                                                                                    swal(t("error"), "", "error");
                                                                                    fetchWithdrawals();
                                                                                });
                                                                        }}
                                                                        disabled={item?.status_payment !== "Pending"}>
                                                                        {t("confirm")}
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            setLoading(true);
                                                                            const formData = {
                                                                                id: item?._id,
                                                                                status: "Deny",
                                                                                note: note
                                                                            };
                                                                            axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                .then(() => {
                                                                                    swal(t("success"), "", "success");
                                                                                    fetchWithdrawals(); // Fetch lại thay vì reload
                                                                                })
                                                                                .catch(() => {
                                                                                    swal(t("error"), "", "error");
                                                                                    fetchWithdrawals();
                                                                                });
                                                                        }}
                                                                        disabled={item?.status_payment !== "Pending"}>
                                                                        {t("deny")}
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <div>{t("not_permission")}</div>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item?.createdAt))}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </Box>
                            </div>
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default Request;